import React from 'react';
import PropTypes from 'prop-types';
import { getFares } from '../../../_integrations/everymundo/travelClasses';
import SkeletonMultipleTravelClasses from '../../others/Skeleton/SkeletonMultipleTravelClasses';
import FaresGridBackgroundImage from '../FaresGridBackgroundImage';
import FareItemTravelClasses from '../../items/FareItemTravelClasses/FareItemTravelClasses.jsx';

const MultipleTravelClassesListContainer = (props) => (
  <FaresGridBackgroundImage
    SkeletonInstance={SkeletonMultipleTravelClasses}
    ItemComponentInstance={FareItemTravelClasses}
    {...props}
    getFares={getFares}
  />
);

MultipleTravelClassesListContainer.componentName = 'MultipleTravelClassesListContainer';

MultipleTravelClassesListContainer.propTypes = {
  /**
   * Parameters tracking
   */
  tracking: PropTypes.objectOf(PropTypes.any)
};

MultipleTravelClassesListContainer.defaultProps = {
  tracking: {
    flexibleDates: false,
    passengerCount: 1,
    promoCode: 'EVERYMUNDO',
    eventType: 'multipleTravelClassesListContainer'
  }
};

export default MultipleTravelClassesListContainer;
